import { putApiGalaxyServer } from 'services';
import ApiClientManager from 'core/apiClient';
import { UpdateSyncFrequencyParams, UpdateSyncFrequencyResponse } from 'IntegrationModule/types';

/**
 * Update an integration's daily sync frequency and, optionally, its scheduled
 * UTC sync times via the galaxy-server proxy (GLX-1609, GLX-1656), which
 * forwards to the IS V2 settings endpoint
 * `PUT /provision/saveSettings/:mosaicTeamId/:serviceName/:targetServiceId`.
 *
 * The body is flat (`{ customDailyFetchCount, customDailyFetchTime? }`);
 * galaxy-server re-shapes it into the section-wrapped form the IS expects.
 * `customDailyFetchTime` is only included when non-empty: the IS keeps the
 * stored times when the key is absent, and an empty array would both fail
 * galaxy-server validation and cause nightly IS scheduler alerts.
 */
export const updateSyncFrequencyApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<UpdateSyncFrequencyParams>) => {
  const customHeaders =
    params.tenant && params.realmId
      ? ApiClientManager.buildUrlHeaders({
          tenantName: params.tenant,
          realmId: params.realmId,
        })
      : undefined;

  const {
    mosaicTeamId,
    serviceName,
    targetServiceId,
    customDailyFetchCount,
    customDailyFetchTime,
  } = params;

  return putApiGalaxyServer<
    { customDailyFetchCount: number; customDailyFetchTime?: string[] },
    UpdateSyncFrequencyResponse
  >(
    `/integrations_api/provision/saveSettings/${mosaicTeamId}/${serviceName}/${targetServiceId}`,
    {
      customDailyFetchCount,
      ...(customDailyFetchTime?.length ? { customDailyFetchTime } : {}),
    },
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
